import fencesDatabase  from '@/domains/blog/databases/fences.json';
import {ClipboardIcon} from '@heroicons/react/24/outline';
import md5             from 'md5';

export function Torchlight({
	                           children,
	                           language,
	                           theme,
	                           name,
	                           includeCopy = true,
                           }) {
	const hash = md5('' + language + theme + children);

	const formattedContent = fencesDatabase[hash] ?? null;

	if (formattedContent !== null) {
		return (<div className="not-prose relative flex-1">
			{includeCopy &&
				<button className="absolute top-2 right-3 text-white/50 hover:text-white z-10 bg-white/5 hover:bg-white/25 p-1 rounded-lg"
				        title="Copy to clipboard"
				        onClick={() => navigator.clipboard.writeText(children)}
				>
					<ClipboardIcon className="h-5 w-5" />
				</button>}

			<div className="h-full"
			     dangerouslySetInnerHTML={{__html: formattedContent}}
			>
			</div>
		</div>);
	} else {
		return (<pre>{children}</pre>);
	}
}
